import { useState } from 'react';
import { Card, Col, Form, Row, Tab } from 'react-bootstrap';
import { density } from '@/app/PageSpeed/config/internalSeoColumnConfig';
import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import type { ComponentType } from 'react';
import type {
  AnalysisPageContent,
  DensityStats
} from '@/app/PageSpeed/api/types/analysisApiTypes';

type AgGridWrapperProps = {
  height?: string;
  columns?: unknown[];
  data?: unknown[];
};
const TypedAgGridWrapper = AgGridWrapper as ComponentType<AgGridWrapperProps>;

type Props = {
  contentData?: AnalysisPageContent | null;
  densityStats?: DensityStats | null;
};

export const DensityTabContent = ({ contentData, densityStats }: Props) => {
  const [eventKey, setEventKey] = useState<string | number>(2);
  const densityContent = contentData?.content || {};
  const stats = densityStats || {};
  const densityCounts = {
    1: densityContent.word_density_array_1?.length || 0,
    2: densityContent.word_density_array_2?.length || 0,
    3: densityContent.word_density_array_3?.length || 0,
    4: densityContent.word_density_array_4?.length || 0,
    5: densityContent.word_density_array_5?.length || 0
  };

  const navItems = [
    {
      id: 1,
      name: 'چگالی ۱ کلمه',
      tooltip: '',
      columns: density,
      data: densityContent.word_density_array_1 || []
    },
    {
      id: 2,
      name: 'چگالی ۲ کلمه',
      tooltip: '',
      columns: density,
      data: densityContent.word_density_array_2 || []
    },
    {
      id: 3,
      name: 'چگالی ۳ کلمه',
      tooltip: '',
      columns: density,
      data: densityContent.word_density_array_3 || []
    },
    {
      id: 4,
      name: 'چگالی ۴ کلمه',
      tooltip: '',
      columns: density,
      data: densityContent.word_density_array_4 || []
    },
    {
      id: 5,
      name: 'چگالی ۵ کلمه',
      tooltip: '',
      columns: density,
      data: densityContent.word_density_array_5 || []
    }
  ];

  return (
    <>
      <div className="d-flex justify-content-end mb-3">
        <Form.Select
          size="sm"
          className="w-auto"
          onChange={({ target }) => setEventKey(target.value)}
          defaultValue={eventKey}
        >
          <option value={1}>
            چگالی ۱ کلمه (
            {Math.max(stats.word_density_array_1 || 0, densityCounts[1])})
          </option>
          <option value={2}>
            چگالی ۲ کلمه (
            {Math.max(stats.word_density_array_2 || 0, densityCounts[2])})
          </option>
          <option value={3}>
            چگالی ۳ کلمه (
            {Math.max(stats.word_density_array_3 || 0, densityCounts[3])})
          </option>
          <option value={4}>
            چگالی ۴ کلمه (
            {Math.max(stats.word_density_array_4 || 0, densityCounts[4])})
          </option>
          <option value={5}>
            چگالی ۵ کلمه (
            {Math.max(stats.word_density_array_5 || 0, densityCounts[5])})
          </option>
        </Form.Select>
      </div>
      <Tab.Container id="density-tab" activeKey={eventKey}>
        <Row>
          <Col xxl={12}>
            <Tab.Content>
              {navItems.map(item => (
                <Tab.Pane key={item.id} unmountOnExit eventKey={item.id}>
                  {item.data && (
                    <TypedAgGridWrapper
                      height="746px"
                      columns={item.columns}
                      data={item.data}
                    />
                  )}
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </>
  );
};

const DensityTabs = (props: Props) => (
  <Card className="mt-3">
    <FalconCardHeader
      title={<div>چگالی کلمات</div>}
      titleTag="h6"
      className="py-2"
      light
    />
    <Card.Body>
      <DensityTabContent {...props} />
    </Card.Body>
  </Card>
);

export default DensityTabs;
